import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  UserDTO
} from '../../api/plyca-dtos';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ServiceLocator } from './../../ServiceLocator';

import { UserService } from '../../user.service';
import {
  userDetailComponent,
  UserDetailDTOModal
} from '../userDetail/userDetail.component';

import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

@Component({
  selector: 'user',
  templateUrl: 'user.template.html'
})
export class userComponent extends BaseComponent
  implements OnInit, OnDestroy {
  @Input()
  user: UserDTO;

  fullName: string;
  lettersName: string;

  constructor(private translateService: TranslateService,
    public dialogService: DialogService,
    private userService: UserService) {
    super();

  }

  updateUser() {
    console.log('No se ha recibido nombre en el usuario ', this.user);
  }

  updateUserFullName() {
    this.fullName = this.userService.calculateUserFullName(this.user);
    this.lettersName = this.userService.calculateUserLetters(this.user);
  }

  ngOnInit(): void {
    if (this.user) {
      if (
        (!this.user.person || !this.user.person.name) &&
        (this.user.identifier && this.user.identifier.toLowerCase() != 'system')
      ) {
        this.updateUser();
      }
      this.updateUserFullName();
    }
  }

  afterLoadComplete() {
    console.log('afterLoadComplete');
  }

  public isLoaded(): boolean {
    return true;
  }
  ngOnDestroy() {


    super.ngOnDestroy();
  }
  viewUserDetail(user: UserDTO) {

    let context = new UserDetailDTOModal(user);
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('UserDetail.detail'),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };

    config['context'] = new UserDetailDTOModal(user);
    const ref = this.dialogService.open(userDetailComponent, config);
    this.subscribe(ref.onClose);



  }
}
